import axios from "axios";
import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export const updateDisableProduct = async (
  endpoint: string,
  id: string,
  enable: boolean
) => {
  try {
    const url = endpoint + id;
    const payload = {
      productData: { id: id, disabled: enable },
    };
    const response = await api.put(url, payload, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data.data.product;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data || error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw new Error("Failed to update product status");
  }
};
